import {
    Box,
    DialogContent,
    Typography,
    Dialog,
    Button,
    TypographyProps
} from '@mui/material';
import { styled } from '@mui/material/styles';
import color from 'src/theme/color';

export const StyledDialogContent = styled(DialogContent)(() => ({
    padding: 0
}));

export const StyledDialogContainer = styled(Box)(() => ({
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    width: '80%',
    margin: '0 auto',
    color: 'white'
}));

export const StyledHeaderContainer = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20
}));

export const StyledDialog = styled(Dialog)(() => ({
    '& .MuiPaper-root': {
        backgroundColor: '#151721',
        borderRadius: '8px',
        width: '30%',
        maxWidth: '100%'
    }
}));

export const StyledHeaderTypography = styled(Typography)<TypographyProps>(
    () => ({
        flex: 1,
        textAlign: 'center'
    })
);

export const StyledEmailTypography = styled(Typography)<TypographyProps>(
    () => ({
        textAlign: 'center',
        marginTop: 16,
        color: color.grey3
    })
);

export const StyledActionBox = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 24,
    marginBottom: 16
}));

export const StyledResendButton = styled(Button)(() => ({
    minWidth: '140px',
    backgroundColor: color.yellowButton,
    '&:hover': {
        backgroundColor: color.yellowButton
    }
}));

export const actionBoxStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '24px',
    marginBottom: '16px'
};

export const resendButtonStyle = {
    minWidth: '140px'
};
